export default __webpack_public_path__ + "static/media/A10.35a07901.jpg";